
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"40","viewBox":"0 0 36 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.914 40c-3.577-5.19-7.151-10.335-10.977-15.337C3.567 20.256.07 15.505.07 9.641.07 4.772 2.858 0 8.084 0c3.976 0 7.436 2.962 8.358 6.87.638 2.706 2.326 2.742 3.082.001 1.104-4 4.15-6.836 8.322-6.836 5.325 0 8.084 4.699 8.084 9.676 0 5.81-3.616 10.762-6.987 15.11C25.106 29.77 21.503 34.865 17.914 40","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    